import { InspectionInstanceStatus } from 'graphql-query-contracts';

export const STATUS_TRANSLATION_KEYS: Record<InspectionInstanceStatus, string> =
  {
    [InspectionInstanceStatus.Scheduled]:
      'web.admin.inspections.table.statusScheduled',
    [InspectionInstanceStatus.InProgress]:
      'web.admin.inspections.table.statusInProgress',
    [InspectionInstanceStatus.Completed]:
      'web.admin.inspections.table.statusCompleted',
    [InspectionInstanceStatus.Closed]:
      'web.admin.inspections.table.statusClosed',
  };

export const FILTERABLE_INSPECTION_STATUSES: InspectionInstanceStatus[] = [
  InspectionInstanceStatus.InProgress,
  InspectionInstanceStatus.Completed,
];
